import { Queue, QueueCondition, TaskManagementService } from 'src/app/services/api/taskmanagement/taskmanagement.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { QueueConditionField } from 'src/app/models/taskmanagement/queue-condition-field.enum'
import { QueueConditionOperation } from 'src/app/models/taskmanagement/queue-condition-operation.enum'
import { QueueConditionObject } from 'src/app/models/taskmanagement/queue-condition-object.model'
import { QueueObject } from 'src/app/models/taskmanagement/queue-object.model'
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-queue',
  templateUrl: './add-queue.component.html',
  styleUrls: ['./add-queue.component.scss']
})

export class AddQueueComponent implements OnInit {

  form: FormGroup;

  tooltip = {
    submit: '',
    reset: '',
    addCondition: ''
  };

  queueFieldDomainOptions:Array<string>=["MOBILE","FTTH","TV"];
  queueFieldTaskType: Array<string> = ["TechnicalError","SCAIError"]
  queueConditionsFieldOptions: any[] = [];
  queueConditionsOperationOptions: any[] = [];

  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private notificationsService: NotificationsService,
    private taskmanagementService:TaskManagementService,
    private router: Router,
    ) { }

  get queueNameForm(){
    return this.form.get('queueName');
  }
  get queueDescForm(){
    return this.form.get('queueDesc');
  }
  get queueRoleForm(){
    return this.form.get('queueRol');
  }
  get queuePriorityForm(){
    return this.form.get('queuePriority');
  }
  get queueConditionsForm(){
    return this.form.get('queueConditionsForm') as FormArray;
  }


  ngOnInit() {

    for (let item in QueueConditionField) {
      if (isNaN(Number(item))) {
        this.queueConditionsFieldOptions.push({ text: item, value: QueueConditionField[item] });
      }
    }
    for (let item in QueueConditionOperation) {
      if (isNaN(Number(item))) {
        this.queueConditionsOperationOptions.push({ text: item, value: QueueConditionOperation[item] });
      }
    }

    this.initForm();
    this.initTooltips();
  }

  initForm(){
    this.form = this.formBuilder.group({
      queueName: this.formBuilder.control({value:'',disabled: false},Validators.required),
      queueDesc: this.formBuilder.control({value:'',disabled:false},Validators.required),
      queueRol: this.formBuilder.control({value: '',disabled: false},Validators.required),
      queuePriority: this.formBuilder.control({value: 100, disabled: false}, [Validators.required, Validators.min(1), Validators.max(999)]),
      queueConditionsForm: this.formBuilder.array([])
    });
    this.addQueueCondition();
  }


  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
      this.tooltip.reset = this.translate.instant('TOOLTIPS.resetForm');
      this.tooltip.addCondition = this.translate.instant('TOOLTIPS.addQueueCondition');
    });
  }

  clearForm() {
    this.form.reset();
    this.initForm();
  }


  public submitForm() {
    if(this.validateForm()){
      const queue:Queue = new QueueObject();

      queue.name = this.form.get('queueName').value;
      queue.description = this.form.get('queueDesc').value;
      queue.role = this.form.get('queueRol').value;
      queue.priority = this.form.get('queuePriority').value;

      let queueConditions: QueueCondition[]=[];
      for(let item of this.queueConditionsForm.controls){
        const condition:QueueCondition = new QueueConditionObject();
        //conditionUpdated.queueConditionId = item.get("queueConditionId").value;
        condition.field = item.get("field").value;
        condition.operation = item.get("operation").value;
        condition.value = item.get("value").value;
        queueConditions.push(condition);
      }
      queue.conditions = queueConditions;
      this.taskmanagementService.addQueue(queue).subscribe(() =>
      {
        this.notificationsService.showNotification(`La cola ${queue.name} se ha creado correctamente`, NotificationLevel.SUCCESS);
        this.goToSearchQueues();
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al crear la Cola ${queue.name} :\n${error.error.errorDesc.stackTrace}`, NotificationLevel.ERROR);
      });
    }
  }

  validateForm() : boolean{
    for(let item of this.queueConditionsForm.controls){
      if(item.get("field").value == QueueConditionField.Dominio){

        if(this.queueFieldDomainOptions.find((element) => element === item.get("value").value) == undefined){
          this.notificationsService.showNotification(`El valor ${item.get("value").value} no está permitido para el campo Dominio. Valores válidos: ${this.queueFieldDomainOptions}`, NotificationLevel.ERROR);
          return false;
        }
      }
      if(item.get("field").value == QueueConditionField['Tipo de tarea']){

        if(this.queueFieldTaskType.find((element) => element === item.get("value").value) == undefined){
          this.notificationsService.showNotification(`El valor ${item.get("value").value} no está permitido para el campo Tipo de tarea. Valores válidos: ${this.queueFieldTaskType} `, NotificationLevel.ERROR);
          return false;
        }
      }
    }
    return true;
  }

  addQueueCondition(){
    const queueConditionFormGroup  = this.formBuilder.group({
      queueConditionId: '',
      field: '',
      operation: '',
      value: ''
    });
    this.queueConditionsForm.push(queueConditionFormGroup);
  }

  removeQueueCondition(indice: number) {
    this.queueConditionsForm.removeAt(indice);
  }

  goToSearchQueues():void{
    this.router.navigate(["/provision/management/taskmanagement"]);
  }

}
